import React, { memo, useEffect, useRef, useState } from 'react';
import '../../css/Messages.css';
import SelectInput from '../../components/common/ui/Inputs/SelectInput';
import CustomInput from '../../components/common/CustomInput';
import Inbox from './Inbox';
import { useDispatch, useSelector } from 'react-redux';
import PaymentModal from './PaymentModal';
import TextAreaInput from '../../components/common/ui/Inputs/TextAreaInput';
import CustomKeyboard from '../../components/common/CustomKeyboard';
import ScrollContainer from '../../components/common/ScrollContainer';
import CustomModal from '../../components/common/CustomModal ';
import { inboxActions } from '../../_store/inbox.slice';
import { MyContactsActions } from '../../_store/MyContacts.slice';
import Button from '../../components/common/ui/Button';
import Loader from '../../components/common/Loader';
import MyMessageSchema from '../../validation/MyMessageSchema';
import { KioskDashboardActions } from '../../_store';
import TranslateFile from '../../Loc/TranslateFile';
import useKioskRestrictIntervalValidation from '../../hooks/useKioskRestrictIntervalValidation';
import useCheckQuarantineWords from '../../hooks/useCheckQuarantineWords';
import { getStoredValue  } from "../../_helpers/storageHelper";

const MyMessage = () => {
    const currentLang = TranslateFile();
    const [isOpenPaymentModal, setisOpenPaymentModal] = React.useState(false);
    const [isKeyboardOpen, setIsKeyboardOpen] = useState(false);
    const [currentField, setCurrentField] = useState('');
    const [values, setvalues] = useState();
    const allFields = ['subject', 'writeMessage'];
    const placeholder = { subject: currentLang?.placeholder?.Subject, writeMessage: currentLang?.placeholder?.Write_your_message }
    const [errorMessage, setErrorMessage] = useState({});
    const [isLoading, setisLoading] = useState(false);
    const [inmateInboxMessageHistoryList, setinmateInboxMessageHistoryList] = useState([]);
    const [inboxlist, setinboxlist] = useState([]);
    const [formData, setFormData] = useState({
        user: '',
        subject: '',
        writeMessage: '', search: '',
        totalEmojiCost: 0.00,
        totalMessageCost: 0.00,
        showTotalMessageCost: false,
        facilityMessageCost: 0.00, PublicUserID: '',
        facilityEmojiCost: 0.00, pageNo: 1, currentPage: 1,
        balance: 0.00, replyMessageID: '', activeTab: 'inbox', DebitCostOfFacility: '',
        userCredits: 0.00, freeCredits: 0.00, freeCreditStatus: false, isShowList: true, searchinboxlist: [],
    });
    const { CactasServiceDetailsResult, ArchiveinboxMessagesList, InmateInboxMessageResponse, InmatePublicCreditBalanceResultResult, InmateFreeCreditBalanceResult, PublicInboxMessageSubjectList } = useSelector((state) => state.inbox);
    const { LoadInmateMyContactsDisplayDetails } = useSelector(state => state.MyContacts);
    const [showPopup, setShowPopup] = useState(false);
    const [modalContent, setModalContent] = useState();
    const [modalContentColor, setmodalContentColor] = useState();
    const dispatch = useDispatch();
    const { loginResponse, loginDetails } = useSelector(state => state.kioskLogin);
    const storedloginResponse = loginResponse || getStoredValue("loginResponse");
    const storedLoginDetails = getStoredValue("loginDetails") || loginDetails;
    const [isnewChat, setisnewChat] = React.useState('');
    const { innerWidth: width, innerHeight: height } = window;
    const chatContainerRef = useRef(null);
    const [isupdateScroll, setisupdateScroll] = React.useState(false);
    const validateKioskRestrictInterval = useKioskRestrictIntervalValidation();
    const { isPageReload: isPageReloading, isSignalRData, connectionData } = useSelector((state) => state.auth);
    const LoadQuarantineWords = useCheckQuarantineWords();

    useEffect(() => {
        const replyMessageId = inmateInboxMessageHistoryList?.length > 0 ? inmateInboxMessageHistoryList[0]?.ReplyMessageID || inmateInboxMessageHistoryList[0]?.SourceReplyMessageID : 0
        const isSignalRreplyMessageId = isSignalRData?.message?.ReplyMessageID || isSignalRData?.message?.SourceReplyMessageID;
        switch (isSignalRData?.type) {
            case 'Send_Msg':
                if (!formData?.isShowList && inmateInboxMessageHistoryList?.length > 0 && isSignalRreplyMessageId == replyMessageId) {
                    setinmateInboxMessageHistoryList(prevMessages => [
                        ...prevMessages,
                        isSignalRData?.message
                    ]);
                    setisupdateScroll(true);
                    const MessageID = isSignalRData?.message?.MessageID;
                    const inmatesId = isSignalRData?.message?.InmateID;
                    dispatch(inboxActions.LoadInmateInboxMessageSubject({ MessageID, inmatesId }))
                    handlegetSidemenu();
                }
                else if (isSignalRData?.message?.InmatesId) {
                    const Objectdata = {
                        inmatesId: isSignalRData?.message?.InmatesId, messageID: 0, receiverRead: 2, userFirstName: '', userLastName: '', subject: '', messageBody: '', pageNo: 1,
                        sortField: "", rowCountPerPage: 10,
                    };
                    dispatch(inboxActions.LoadInmateInboxMessage(Objectdata));
                }
                break;
            case "Rejected_Msg":
                  if (formData?.isShowList && isSignalRData?.message?.InmateID) {
                    const Objectdata = {
                        inmatesId: isSignalRData?.message?.InmateID, messageID: 0, receiverRead: 2, userFirstName: '', userLastName: '', subject: '', messageBody: '', pageNo: 1,
                        sortField: "", rowCountPerPage: 10,
                    };
                    dispatch(inboxActions.LoadInmateInboxMessage(Objectdata));
                }
                else {
                const updatedchat = inmateInboxMessageHistoryList?.map(card => {
                    if (card?.MessageID == isSignalRData?.message?.MessageId) {
                        const msgtext = card?.Sender == "Inmate" ?
                            card?.MessageBody + " <br/><br/><br/>" + "(Public user canceled this message on - " + isSignalRData?.message?.MessageSentDate + " )"
                            : "(Public user canceled this message on - " + isSignalRData?.message?.MessageSentDate + " )"
                        return {
                            ...card, MessageBody: msgtext, IsSenderMsgDelete: true,
                            MessageBodyText: msgtext, MessageStatus: "C.O.D Pending"
                        };
                    }
                    return card;
                });
                setinmateInboxMessageHistoryList(updatedchat);
            }
                break;
            case "Approved_Msg":
                if (formData?.isShowList && isSignalRData?.message?.InmateID) {
                    const Objectdata = {
                        inmatesId: isSignalRData?.message?.InmateID, messageID: 0, receiverRead: 2, userFirstName: '', userLastName: '', subject: '', messageBody: '', pageNo: 1,
                        sortField: "", rowCountPerPage: 10,
                    };
                    dispatch(inboxActions.LoadInmateInboxMessage(Objectdata));
                }
                else {
                    const updatedchatlist = inmateInboxMessageHistoryList?.map(card => {
                        if (card?.MessageID == isSignalRData?.message?.MessageId) {
                            const msgtext = card?.Sender == "Inmate" ? card?.MessageBody : isSignalRData?.message?.MessageBody
                            if (connectionData?._connectionState == "Connected" && isSignalRData?.message?.SenderType == "PublicUser") {
                                connectionData.invoke("SendSignalRMessagetoPU", { ...PublicInboxMessageSubjectList[0], Messagetxt: msgtext, MessageID: isSignalRData?.message?.MessageId })
                            }
                            else if (connectionData?._connectionState == "Connected") {
                                connectionData.invoke("SendSignalRMessagetoInmate", { ...PublicInboxMessageSubjectList[0], Messagetxt: msgtext, MessageID: isSignalRData?.message?.MessageId })
                            }
                            return {
                                ...card, MessageBody: msgtext,
                                MessageBodyText: msgtext, MessageStatus: "Read",
                            };
                        }
                        return card;
                    });
                    setinmateInboxMessageHistoryList(updatedchatlist);
                }
               
                break;

            case "Read_Msg":
                if (isSignalRreplyMessageId == replyMessageId) {
                    const updatedchatlists = inmateInboxMessageHistoryList?.map(card => {
                        if (card?.MessageStatus == "Unread") {
                            return {
                                ...card, MessageStatus: "Read",
                            };
                        }
                        return card;
                    });
                    setinmateInboxMessageHistoryList(updatedchatlists);
                }
                break;
            case "COD_Read_Msg":
                if (isSignalRreplyMessageId == replyMessageId) {
                    const updatedchatlists = inmateInboxMessageHistoryList?.map(card => {
                        if (card?.MessageID == isSignalRData?.message?.MessageID) {
                            return {
                                ...card, MessageStatus: "Read",
                            };
                        }
                        return card;
                    });
                    setTimeout(() => {
                        setinmateInboxMessageHistoryList(updatedchatlists);
                    }, 800);
                }
                break;
        }
    }, [isSignalRData]);

    useEffect(() => {
        setFormData(prevFormData => ({
            ...prevFormData,
            user: '', search: '',
            subject: '', pageNo: 1, currentPage: 1,
            writeMessage: '', isShowList: true, activeTab: "inbox",
        }));
    }, [isPageReloading])


    const handlegetSidemenu = () => {
        const podCode = storedLoginDetails?.PodCode;
        const inmateID = storedloginResponse?.InmateID;
        if (inmateID && podCode)
            dispatch(KioskDashboardActions.getLoadInmateMainMenu({ inmateID, podCode }));
    }

    const handleTabChange = (tab) => {
        setisnewChat(''); setErrorMessage({});
        setFormData(prevFormData => ({
            ...prevFormData,
            user: '', search: '',
            subject: '', pageNo: 1, currentPage: 1,
            writeMessage: '', isShowList: true, activeTab: tab, searchinboxlist: []
        }));
        setinboxlist((formData?.activeTab === 'inbox' ? InmateInboxMessageResponse : ArchiveinboxMessagesList))
        handlegetSidemenu();
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSend = () => {
        const SelectUser = LoadInmateMyContactsDisplayDetails?.find(
            x => x?.PublicUserEmail === formData?.user);
        dispatch(inboxActions.LoadInmatePublicCreditBalanceResult({
            inmatesId: storedloginResponse?.InmateID,
            userId: SelectUser?.PublicUserID || 0,
            pUIConnectionID: SelectUser?.PUIConnectionID || 0,
        }));
    };

    useEffect(() => {
        handleSend();
        dispatch(inboxActions.LoadInmateFreeCreditBalanceResult({
            inmateResidentID: storedloginResponse?.InmatesResdId,
            facilityId: storedloginResponse?.facilityID,
        }));
        dispatch(MyContactsActions.LoadInmateMyContactsDisplay({ inmatesId: storedloginResponse?.InmateID, userID: 0, connectionStatus: 2 }));
        dispatch(inboxActions.LoadCactasServiceDetailsResult({ facilityId: storedloginResponse?.facilityID }));
    }, [dispatch]);

    useEffect(() => {
        if (InmatePublicCreditBalanceResultResult?.length > 0) {
            setFormData(prevFormData => ({
                ...prevFormData,
                userCredits: InmatePublicCreditBalanceResultResult[0].CreditBalance
            }));
        }
    }, [InmatePublicCreditBalanceResultResult]);

    useEffect(() => {
        if (InmateFreeCreditBalanceResult?.length > 0) {
            const { InmateFreeCreditAmount, FreeCreditActiveStatus } = InmateFreeCreditBalanceResult[0];
            setFormData(prevFormData => ({
                ...prevFormData,
                freeCredits: InmateFreeCreditAmount,
                freeCreditStatus: FreeCreditActiveStatus === 1
            }));
        }
    }, [InmateFreeCreditBalanceResult]);

    useEffect(() => {
        validateKioskRestrictInterval(storedLoginDetails)
    }, []);

    useEffect(() => {
        async function fetchInmateBalance() {
            if (CactasServiceDetailsResult?.length > 0 && CactasServiceDetailsResult[0].IsInmateCactasCredit === 1) {
                const { CactasURL, CactasAccessKey, FacilityMessageCost, FacilityEmojiCost } = CactasServiceDetailsResult[0];
                setFormData(prevFormData => ({
                    ...prevFormData,
                    facilityMessageCost: FacilityMessageCost,
                    facilityEmojiCost: FacilityEmojiCost
                }));
                // const residentID = storedloginResponse?.InmatesResdId;
                // dispatch(inboxActions.LoadInmateBalance({ cactasURL: CactasURL, cactasAccessKey: CactasAccessKey, residentID: residentID })).then((x) => {
                //     if (x?.payload) {
                //         const balanceValue = parseFloat(x?.payload) || 0;
                //         setFormData(prevFormData => ({
                //             ...prevFormData,
                //             balance: Math.round(balanceValue * 100) / 100
                //         }));
                //     }
                // });
            }
        }

        fetchInmateBalance();
    }, [CactasServiceDetailsResult]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setErrorMessage({});
        const { error } = MyMessageSchema(formData);
        if (error) {
            error.details.forEach((e) => {
                setErrorMessage((prev) => ({
                    ...prev,
                    [e.path.toString()]: e.message,
                }));
            });
            return;
        }
        // const x = await LoadQuarantineWords(formData?.writeMessage + formData?.subject);
        // if (x?.isQuarantineWords && x?.highlightedWords) {
        //     setModalContent(`Your message contains restricted word(s): ${x.highlightedWords}. Please remove the word and try again.`);
        //     setmodalContentColor('#c8605e');
        //     setShowPopup(true);
        //     return;
        // } else {
        await handleSend();
        setisOpenPaymentModal(true);
        // }
    };

    const handleFieldClick = (field) => {
        setCurrentField(field);
        setIsKeyboardOpen(true);
        setvalues(formData);
    };

    const handleMessageResponse = (data) => {
        const messages = {
            "1": {
                text: currentLang?.Message_Popup?.Message_sent_successfully,
                color: "#4a9a93",
                resetForm: true,
            },
            "-2": {
                text: currentLang?.Message_Popup?.COD_Message,
                color: "#c8605e",
                resetForm: true,
            },
            "-3": {
                text: currentLang?.Message_Popup?.Repeated_Message,
                color: "#c8605e",
                resetForm: true,
            },
            "-4": {
                text: currentLang?.Message_Popup?.Restricted_Message,
                color: "#c8605e",
            },
            "-5": {
                text: currentLang?.ECard_Popup?.CACTAS_credits_not_enabled,
                color: "#c8605e",
            },
            "-6": {
                text: currentLang?.ECard_Popup?.Credit_Balance_Low,
                color: "#c8605e",
            },
            "-7": {
                text: currentLang?.ECard_Popup?.Connection_Blocked,
                color: "#c8605e",
            },
        };

        const messageConfig = messages[data];
        if (messageConfig) {
            setModalContent(messageConfig.text);
            setmodalContentColor(messageConfig.color);
            setShowPopup(true);

            if (messageConfig.resetForm) {
                setFormData((prevFormData) => ({
                    ...prevFormData,
                    user: "",
                    subject: "",
                    writeMessage: "",
                }));
            }
        }
    };


    // Save Function 

    const SendMessage = async (paymentType, taskGUID, balanceValue) => {
        setisnewChat('');
        try {
            setisOpenPaymentModal(false);
            setisLoading(true);
            const PublicUserID = LoadInmateMyContactsDisplayDetails?.find(
                x => x?.PublicUserEmail === formData?.user
            )?.PublicUserID || 0;
          
            var IsQuarantine = false;
            const x = await LoadQuarantineWords(formData?.activeTab === 'write' ? formData?.writeMessage + formData?.subject : formData?.writeMessage);
            if (x?.isQuarantineWords && x?.highlightedWords) {
                IsQuarantine = true
            }

            const apiData = {
                IsQuarantine : IsQuarantine,
                publicUserID: PublicUserID ? PublicUserID : formData?.PublicUserID,
                inmateID: storedloginResponse?.InmateID,
                facilityId: storedloginResponse?.facilityID,
                paymentType: (paymentType == '3') ? '4' : paymentType,
                // paymentType: (formData?.activeTab === 'write' && paymentType == '3') ? '4': paymentType,
                cactasBalanceAmount: balanceValue,
                replyMessageID: formData?.activeTab === 'write' ? '' : formData?.replyMessageID,
                totalMessageCost: formData?.totalMessageCost,
                usedMessageEmojiCost: formData?.totalEmojiCost > 0 ? formData?.totalEmojiCost : 0,
                messagetitle: formData?.subject,
                messagetxt: formData?.writeMessage,
                messageID: "",
                inmatesFullName: storedloginResponse?.InmateFullName,
                kioskMachineID: storedLoginDetails?.KiosksCode,
                podCode: storedLoginDetails?.PodCode,
                messageCost: formData?.totalMessageCost,
                inmateResidentId: storedloginResponse?.InmatesResdId,
                taskGUID: taskGUID
            };

            // Write Message Api Any issue Use Below Inbox Send Message API 

            // const inboxapi ={
            //     messageID:formData?.replyMessageID,
            //     inmateID:  storedloginResponse?.InmateID,
            //     publicUserID: PublicUserID ? PublicUserID : formData?.PublicUserID,
            //     msgSubject: formData?.subject,
            //     msgContent: formData?.writeMessage,
            //     messageCost: formData?.totalMessageCost,
            //     accountType: paymentType,
            //     cactaBalance: formData?.balance,
            //     usedEmojiCost:formData?.totalEmojiCost > 0 ? formData?.totalEmojiCost : 0,
            //     facilityID: storedloginResponse?.facilityID,
            //     inmateResidentId: storedloginResponse?.InmatesResdId,
            //     taskGUID: taskGUID,
            //     inmatesFullName: storedloginResponse?.InmateFullName,
            //     kioskMachineID: storedLoginDetails?.KiosksCode,
            //     podCode: storedLoginDetails?.PodCode,
            // }

            // if(formData?.activeTab === 'write'){
            dispatch(inboxActions.LoadSendMessage(apiData)).then(async (x) => {
                setisOpenPaymentModal(false);
                if (formData?.replyMessageID) {
                    setTimeout(async () => {
                        await loadMoreMessages(formData?.replyMessageID, 1, 0, formData?.currentPage == 1 ? false : true, true);
                    }, 100);
                    setisupdateScroll(true);
                }
                if (x?.payload?.data) {
                    setisLoading(false);
                    handleMessageResponse(x?.payload?.data)                  
                }
                if (x?.payload?.IsSucceed > 0 && x?.payload?.IsSucceed != -100) {
                    const notificationparams = { ...apiData, IsSucceed: x?.payload?.IsSucceed }
                    dispatch(inboxActions.LoadSendNotificationandEmail(notificationparams));
                }
                if (chatContainerRef?.current) {
                    chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
                }
                dispatch(inboxActions.LoadInmateFreeCreditBalanceResult({
                    inmateResidentID: storedloginResponse?.InmatesResdId,
                    facilityId: storedloginResponse?.facilityID,
                }));
            })


        } catch (error) {
            console.error("Error sending message:", error);
        }
    };

    // const handleResponse =(value)=>{ 
    //     switch (value) {
    //         case -1:
    //             setModalContent("Insert Failed)"); setmodalContentColor('#c8605e');
    //         case -2:
    //             setModalContent(" Reapeated Messages)"); setmodalContentColor('#c8605e');
    //             break;
    //         case -6:
    //             setModalContent("Credit balance Low (Restricted COD option for Inmate)"); setmodalContentColor('#c8605e');
    //             break;
    //         case -3:
    //             setModalContent("public User - Inmate Connection is Inactive"); setmodalContentColor('#c8605e');
    //             break;
    //         case -7:
    //             setModalContent("Free credits not enabled to send message"); setmodalContentColor('#c8605e');
    //             break;
    //         case -4:
    //             setModalContent("CACTAS credits not enabled to send message)"); setmodalContentColor('#c8605e');
    //             break;
    //         default:
    //         setModalContent("Message sent successfully"); setmodalContentColor('#4a9a93');
    //           setFormData(prevFormData => ({
    //             ...prevFormData,
    //             user: '',
    //             subject: '',
    //             writeMessage: '',
    //         }));
    //           break;
    //       }
    //       setShowPopup(true);
    // }

    const handleNewChat = (chat) => {
        handleTabChange('write'); setisnewChat(chat);
        const PublicUserEmail = LoadInmateMyContactsDisplayDetails?.find(
            x => x?.PublicUserID === chat?.PublicUserID
        )?.PublicUserEmail || '0';
        setFormData(prevFormData => ({
            ...prevFormData,
            user: PublicUserEmail
        }));
    }

    const loadMoreMessages = (MessageID, page, holdCOD = 0, isLoadMore = false, isgetSubject = false) => {
        const isHoldCOD = holdCOD;
        const rowCountPerPage = isLoadMore ? (formData?.currentPage * 10) : 10;
        dispatch(inboxActions.LoadInmateInboxMessageHistory({
            MessageID,
            isHoldCOD,
            pageNo: page,
            rowCountPerPage
        })).then((historyResponse) => {
            if (historyResponse.payload && historyResponse?.payload?.length > 0) {
                if (page == 1) {
                    setinmateInboxMessageHistoryList(historyResponse.payload);
                }
                else {
                    setinmateInboxMessageHistoryList(prevMessages => [
                        ...historyResponse?.payload, ...prevMessages
                    ]);
                }
                if (isgetSubject && PublicInboxMessageSubjectList?.length > 0 && PublicInboxMessageSubjectList[0]?.MessageSubject == "C.O.D Pending") {
                    let MessageID = historyResponse?.payload[historyResponse?.payload?.length - 1]?.MessageID; let inmatesId = PublicInboxMessageSubjectList[0]?.InmateID;
                    dispatch(inboxActions.LoadInmateInboxMessageSubject({ MessageID, inmatesId }))
                }
            }
        });
    };

    const renderMessage = () => {
        return (
            <>
                <div className="tabs-container">
                    <div className="tabs-group">
                        <button title={currentLang?.Messages?.Inbox}
                            className={`tab-btn ${formData?.activeTab === 'inbox' ? 'active' : ''}`}
                            onClick={() => handleTabChange('inbox')}
                        >
                            <i className="fas fa-inbox me-2"></i> {currentLang?.Messages?.Inbox}
                        </button>
                        <button title={currentLang?.Messages?.Write_Message}
                            className={`tab-btn ${formData?.activeTab === 'write' ? 'active' : ''}`}
                            onClick={() => handleTabChange('write')}
                        >
                            <i className="fas fa-pencil-alt me-2"></i> {currentLang?.Messages?.Write_Message}
                        </button>
                        <button title={currentLang?.Messages?.Archived}
                            className={`tab-btn ${formData?.activeTab === 'archived' ? 'active' : ''}`}
                            onClick={() => handleTabChange('archived')}
                        >
                            <i className="fas fa-archive me-2"></i> {currentLang?.Messages?.Archived}
                        </button>
                    </div>
                    {formData?.freeCreditStatus && <div className="message-cost">
                        <label className="msg-cost">
                            {currentLang?.Messages?.AVAILABLE_FREE_CREDITS}
                            <span className="cost-value ml-5">
                                $<span id="spnMessageCost">{parseFloat(formData?.freeCredits || 0).toFixed(2)}</span>
                            </span>
                        </label>
                    </div>}
                </div>
                <div >
                    {formData?.activeTab === 'write' ? (
                        <div className='p-3'>
                            <div className="message-cost">
                                <label className="msg-cost">
                                    {currentLang?.Messages?.Message_Cost}
                                    <span className="noWrap class-balance ml-5 cost-value">
                                        $<span id="spnMessageCost">{parseFloat(formData?.facilityMessageCost || 0).toFixed(2)}</span>
                                    </span>
                                </label>
                                {(CactasServiceDetailsResult?.length > 0 && CactasServiceDetailsResult[0]?.IsEmojiEnabled) && <> <label className="msg-cost">
                                    {currentLang?.Messages?.Emoji_Cost}
                                    <span className="cost-value ml-5">
                                        $<span id="spnEmojiCost">{parseFloat(formData?.facilityEmojiCost || 0).toFixed(2)}</span>
                                    </span>
                                </label>
                                    <label className="ms-2 mt-1">
                                        <i onClick={() => {
                                            setShowPopup(true); setModalContent(currentLang?.AlertPopup?.Same_Emoji_Content)
                                            setmodalContentColor('#1d1d1d')
                                        }} className="fa fa-info-circle info-emoji"></i>
                                    </label></>
                                }
                            </div>
                            <form className="write-message-form" onSubmit={handleSubmit}>
                                <SelectInput
                                    options={LoadInmateMyContactsDisplayDetails?.filter(x => x?.ConnectionStatusID != 3 && x?.ConnectionStatusID != 4)?.sort((a, b) => a.PublicUserName.localeCompare(b.PublicUserName))}
                                    labelKey='PublicUserName'
                                    valueKey='PublicUserEmail'
                                    label=""
                                    isDisabled={isnewChat?.PublicUserID ? true : false}
                                    name="user"
                                    value={formData.user}
                                    isClearable={false}
                                    placeholder={currentLang?.Messages?.User_Placeholder}
                                    errorMessage={errorMessage}
                                    handleChange={e => {
                                        setFormData({ ...formData, ["user"]: e.value });
                                        setErrorMessage((prev) => ({
                                            ...prev,
                                            user: e.value ? "" : currentLang?.ValidationSchema?.User_Required,
                                        }));
                                    }}
                                />
                                <CustomInput
                                    type="text"
                                    placeholder={currentLang?.Messages?.Subject_Placeholder}
                                    value={formData.subject}
                                    onClick={() => handleFieldClick('subject')}
                                    //onChange={(e) => setFormData({ ...formData, ["subject"]: e.target?.value })}
                                    errorMessage={errorMessage?.subject}
                                />
                                <TextAreaInput
                                    name="writeMessage"
                                    id="message"
                                    label=""
                                    value={formData.writeMessage}
                                    onClick={() => handleFieldClick('writeMessage')}
                                    handleChange={handleInputChange}
                                    placeholder={currentLang?.Messages?.WriteMessage_Placeholder}
                                    rows={4}
                                    errorMessage={errorMessage}
                                />
                                <div className="d-flex justify-content-start mt-30">
                                    <Button label={currentLang?.Buttons?.Send} className='me-2' status="primary" type="submit" onClick={handleSubmit} />
                                    <Button label={currentLang?.Buttons?.Reset} className="btn btn-warning" type="button" onClick={() => { setFormData(prevFormData => ({ ...prevFormData, user: '', subject: '', writeMessage: '', })); setisnewChat(''); setErrorMessage({}) }} />
                                </div>
                                <p className="textnote">{currentLang?.Messages?.Textnote}</p>
                            </form>
                        </div>
                    ) : (
                        <Inbox inboxlist={inboxlist} setinboxlist={setinboxlist} isupdateScroll={isupdateScroll} setisupdateScroll={setisupdateScroll} chatContainerRef={chatContainerRef} loadMoreMessages={loadMoreMessages} inmateInboxMessageHistoryList={inmateInboxMessageHistoryList} setinmateInboxMessageHistoryList={setinmateInboxMessageHistoryList} isLoading={isLoading} setisOpenPaymentModal={setisOpenPaymentModal} handleNewChat={handleNewChat} formData={formData} setFormData={setFormData} />
                    )}
                </div></>
        );
    };

    return (
        <div className="dashboard-container">
            <div className="dashboard-content">
                <div className="icon-container">
                    <h3 className="find-inmate-head">{currentLang?.Messages?.Messages}</h3>
                </div>
                <div className="divider mb-3"></div>
                <div className='card-default'>
                    <ScrollContainer maxHeight={height - 250}>
                        {renderMessage()}
                    </ScrollContainer>
                </div>
                {isOpenPaymentModal && <PaymentModal CactasServiceDetailsResult={CactasServiceDetailsResult[0]} setFormData={setFormData} SendMessage={SendMessage} formData={formData}
                    show={isOpenPaymentModal} onClose={() => { setisOpenPaymentModal(false) }} />}
                {isKeyboardOpen && (
                    <CustomKeyboard
                        currentField={currentField}
                        setCurrentField={setCurrentField}
                        inputs={formData}
                        setShowBoard={setIsKeyboardOpen}
                        setInputs={setFormData}
                        fields={allFields}
                        setErrorMessage={setErrorMessage}
                        type="Multiple"
                        handleCancel={() => { setFormData(values); setIsKeyboardOpen(false) }}
                        setValues={setvalues}
                        placeholderList={placeholder}
                        IsEmojiEnabled={CactasServiceDetailsResult[0]?.IsEmojiEnabled}
                    />
                )}
                {showPopup && (
                    <CustomModal
                        color={modalContentColor}
                        content={modalContent}
                        onOkClick={() => setShowPopup(false)}
                    />
                )}
                {isLoading && <Loader isConvo={true} />}
            </div>
        </div>
    );
};

export default memo(MyMessage);
